/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input, Optional, TemplateRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[ghGridOptionBarTemplate]',
})
export class GridOptionBarTemplateDirective {
  private _templateFromConstructor?: TemplateRef<any>;
  private _template: TemplateRef<any>;

  @Input('ghGridOptionBarTemplate')
  set template(template: TemplateRef<any>) {
    this._template = this._templateFromConstructor || template;
  }

  get template(): TemplateRef<any> {
    return this._templateFromConstructor || this._template;
  }

  constructor(@Optional() private templateRef: TemplateRef<any>) {
    this._templateFromConstructor = templateRef;
  }
}
